import { InputNumber as AntdInputNumber } from 'antd';
import propTypes from 'prop-types';

const keyDownBase = (e, min, integerOnly, decimalLimit, maxLength) => {
  const allowedKeys = ['Backspace', 'Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter'];

  if (allowedKeys.includes(e.key) || e.ctrlKey) return;

  let allowedChars = '0-9';
  allowedChars += min != undefined && min >= 0 ? '' : '-';
  allowedChars += integerOnly ? '' : '.';

  if (!new RegExp(`[${allowedChars}]`).test(e.key)) {
    return e.preventDefault();
  }

  const { selectionStart, selectionEnd, value } = e.target;

  // Max length kontrolü ekleyelim
  if (maxLength && value.length >= maxLength && selectionStart === value.length) {
    return e.preventDefault(); // Eğer değerin uzunluğu maxLength'e ulaşmışsa, daha fazla karakter girmeye engel oluruz
  }

  if (e.key === '-') {
    if (selectionStart !== 0 || (selectionStart === selectionEnd && value[0] === '-')) {
      return e.preventDefault();
    }
    return true;
  }

  if (e.key === '.') {
    if (value.includes('.')) {
      return e.preventDefault();
    }
    return;
  }

  if (value.includes('.')) {
    const [integerPart, decimalPart] = value.split('.');

    if (decimalPart && decimalPart.length >= decimalLimit && selectionStart > value.indexOf('.')) {
      return e.preventDefault();
    }
  }
};

function InputNumber({
  min,
  max,
  integerOnly,
  defaultValue,
  value /* Andt Form value propsu üzerinden iletim yapıyor (SetField, InitialValue vs..) , hiç çağrılmamış olsa da silinmemeli */,
  onChange,
  onPressEnter,
  onBlur,
  name,
  className,
  disabled,
  addonBefore,
  decimalLimit,
  maxLength,
  placeholder,
}) {
  const safeDecimalLimit = typeof decimalLimit === 'number' ? decimalLimit : 2;

  const inputProps = {
    onChange,
    onPressEnter,
    defaultValue,
    value,
    onBlur,
    min,
    max,
    disabled,
    onKeyDownCapture: (e) => {
      keyDownBase(e, min, integerOnly, safeDecimalLimit, maxLength);
    },
    className,
    addonBefore,
    placeholder,
  };
  if (name) {
    inputProps.name = name;
  }
  return <AntdInputNumber {...inputProps} />;
}

InputNumber.propTypes = {
  min: propTypes.number,
  max: propTypes.number,
  integerOnly: propTypes.bool,
  defaultValue: propTypes.number,
  value: propTypes.number,
  onChange: propTypes.func,
  onPressEnter: propTypes.func,
  onBlur: propTypes.func,
  name: propTypes.string,
  className: propTypes.string,
  disabled: propTypes.bool,
  addonBefore: propTypes.string,
  decimalLimit: propTypes.number,
  maxLength: propTypes.number,
  placeholder: propTypes.string,
};

export default InputNumber;
